import { useEffect, useState } from 'react';
import { createBrowserClientSupa } from '@/utils/supabase/createBrowserClient';
import { Session } from '@supabase/supabase-js';

export const useGetSupabaseSession = () => {
  const [session, setSession] = useState<Session | null | undefined>(undefined);

  // If we intend to make this a server component the page is opted-out of
  // static rendering even if we surround the componet in a Suspense boundary
  useEffect(() => {
    const getSession = async () => {
      const supabase = createBrowserClientSupa();
      const { data, error } = await supabase.auth.getSession();
      if (!error && data) {
        setSession(data.session);
      }
    };

    // If on server, do nothing
    if (globalThis.window) {
      getSession();
    }
  }, []);

  return session;
};
